export enum CompanySetting {
  PrintDocument = 1,
  DownloadDocument = 2,
  AnnotateDocument = 3,
  DeleteAnnotationAtMidnight = 4,
  DeleteAfter7Days = 5,
  DeleteAfter30Days = 6,
  ReceivePushNotifications = 7,
  DailyDigestEmailOptOut = 8,
  TwoFactor = 9,
  DoNotRememberDevice = 10,
  RememberDevice30Days = 11,
  RememberDevice60Days = 12,
  RememberDevice90Days = 13,
  AlwaysRememberDevice = 14,
  PurgeCommentsMidnight = 15,
  PurgeCommentsSevenDays = 16,
  PurgeCommentsMonth = 17,
  NoDiscussionNotificationForAdmins = 18,
  DiscussionNotificationOnEveryCommentForAdmins = 19,
  DiscussionNotificationOnFirstCommentForAdmins = 20,
  NoDiscussionNotificationForStandardUsers = 21,
  DiscussionNotificationOnEveryCommentForStandardUsers = 22,
  DiscussionNotificationOnFirstCommentForStandardUsers = 23,
  RemindOneDayBeforeMeeting = 24,
  RemindThreeDaysBeforeMeeting = 25,
  RemindFiveDaysBeforeMeeting = 26,
  RemindOneWeekBeforeMeeting = 27,
  MeetingReminder = 28,
  AutoDeletePrivateMessagesAfter30Days = 29,
  AutoDeletePrivateMessagesAfter60Days = 30,
  AutoDeletePrivateMessagesAfter90Days = 31,
  AutoDeletePrivateMessagesAfter120Days = 32,
  NoUserPrintDocument = 33,
  NoUserDownloadDocument = 34,
  NoUserAnnotateDocument = 35,
  NativeDocumentStorage = 36,
  NativeDocumentMemberAppDownload = 37,
}
